<app-uni-page [parent]="this" pageTitle="Cancel Order Details" [bodyTemplate]="bodyTemplate" [footerTemplate]="footerTemplate"></app-uni-page>

<ng-template #bodyTemplate>
  <div class="flex flex-col h-full p-4 gap-4 overflow-y-auto">

    <!-- STEP 1: J/O search -->
    <div class="qb-detail-card qb-primary-tint p-4">
      <div class="font-semibold text-base mb-2 border-b pb-2 uppercase tracking-wide">
        Step 1: Find the J/O
      </div>
      <div class="flex items-center gap-3">
        <label for="joNumberInput" class="font-semibold">J/O Number:</label>
        <input
          #joSearchInput
          id="joNumberInput"
          pInputText
          type="text"
          inputmode="numeric"
          maxlength="7"
          autocomplete="off"
          [(ngModel)]="joNumberInput"
          (ngModelChange)="onJoNumberInputChange($event)"
          (keydown.enter)="findJoHeader()"
          title="J/O Number"
          class="w-40"
        />
        <button pButton type="button" class="p-button-raised p-button-sm" icon="pi pi-search" (click)="findJoHeader()">
          <span>Search</span>
        </button>
        <button *ngIf="selectedJoHeader" pButton type="button" class="p-button-outlined p-button-sm ml-2" (click)="reset()">
          <span>Reset</span>
        </button>
      </div>
      <div *ngIf="selectedJoHeader" class="mt-3">
        <span class="font-semibold">Selected:</span>
        J/O {{ selectedJoHeader.id }} — {{ selectedJoHeader.account?.accountName }}
      </div>
    </div>

    <!-- STEP 2: cancellable-lines editor -->
    <div *ngIf="selectedJoHeader && cancellableRows.length > 0" class="qb-detail-card qb-primary-tint p-4">
      <div class="font-semibold text-base mb-2 border-b pb-2 uppercase tracking-wide">
        Step 2: Check Details to Cancel and Fill In Each One's Reason
      </div>
      <div class="overflow-x-auto border rounded">
        <table class="w-full text-sm">
          <thead class="sticky top-0 bg-white z-10">
            <tr class="text-left border-b">
              <th class="p-2 w-10"><span class="sr-only">Selected</span></th>
              <th class="p-2">Line #</th>
              <th class="p-2">Product</th>
              <th class="p-2 text-right">Ord</th>
              <th class="p-2 text-right">Alrdy Cxl</th>
              <th class="p-2 text-right">Shipped</th>
              <th class="p-2 text-right">Cancellable</th>
              <th class="p-2 text-right w-24">Cancel Qty</th>
              <th class="p-2 w-64">Reason</th>
              <th class="p-2">Explanation</th>
              <th class="p-2 w-16">Ovrd</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let row of cancellableRows" class="border-b" [class.bg-white]="row.checked">
              <td class="p-2">
                <p-checkbox [(ngModel)]="row.checked" [binary]="true" (onChange)="onRowCheckedChange(row)"></p-checkbox>
              </td>
              <td class="p-2">{{ row.joDetail.id }}</td>
              <td class="p-2">
                {{ row.joDetail.product?.productType?.style }}
                — {{ row.joDetail.product?.productType?.description }}
              </td>
              <td class="p-2 text-right">{{ row.orderQty }}</td>
              <td class="p-2 text-right">{{ row.alreadyCancelled }}</td>
              <td class="p-2 text-right">{{ row.shippedQty }}</td>
              <td class="p-2 text-right">{{ row.cancellableCeiling }}</td>
              <td class="p-2 text-right">
                <input
                  *ngIf="row.checked"
                  pInputText
                  type="number"
                  min="1"
                  [max]="effectiveCeiling(row)"
                  [(ngModel)]="row.cancelQty"
                  title="Cancel qty"
                  class="w-20 text-right"
                />
              </td>
              <td class="p-2">
                <p-dropdown
                  *ngIf="row.checked"
                  [options]="reasonOptions"
                  [(ngModel)]="row.reasonId"
                  optionLabel="label"
                  optionValue="id"
                  placeholder="Reason…"
                  appendTo="body"
                  [style]="{ width: '100%' }"
                ></p-dropdown>
              </td>
              <td class="p-2">
                <input
                  *ngIf="row.checked"
                  pInputText
                  type="text"
                  [(ngModel)]="row.explanation"
                  [placeholder]="row.isOverride ? 'Required for override' : 'Optional'"
                  title="Explanation"
                  class="w-full"
                />
              </td>
              <td class="p-2 text-center">
                <p-checkbox
                  *ngIf="row.checked && isOverrideAvailable(row)"
                  [(ngModel)]="row.isOverride"
                  [binary]="true"
                  (onChange)="onRowOverrideChange(row)"
                  pTooltip="Override normal ceiling (bypass shipped-units gate). Capped at OrderQty − AlreadyCancelled."
                ></p-checkbox>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div class="mt-4 flex items-center gap-3">
        <button pButton type="button" class="p-button-raised p-button-danger" [disabled]="!canSubmit" (click)="submit()">
          <span>
            Cancel {{ totalUnitsToCancel }} {{ totalUnitsToCancel === 1 ? 'unit' : 'units' }}
            across {{ checkedRows.length }} {{ checkedRows.length === 1 ? 'detail' : 'details' }}
          </span>
        </button>
        <span *ngIf="!canSubmit && checkedRows.length > 0" class="text-sm text-red-700">
          Fill in a valid Cancel Qty + Reason for every checked row (explanation required when Override is on).
        </span>
      </div>
    </div>

  </div>
</ng-template>

<ng-template #footerTemplate>
  <div class="left-buttons">
    <button pButton type="button" class="p-button-raised" (click)="goBack()"><span>Go Back</span></button>
  </div>
</ng-template>
